import { useCurrentBrandPlan } from 'hooks/queries/brandPlans/useCurrentBrandPlan'
import { useMemo } from 'react'
import { BrandPlanStrategyType } from 'types'

export const useCampaignsEnabled = () => {
  const { data } = useCurrentBrandPlan({ cacheTime: 5 * 60 * 1000 })

  return useMemo(() => {
    return !!data?.strategy && data.strategy.type !== BrandPlanStrategyType.Evergreen
  }, [data])
}
